import { ChristmasScavenger4Component } from './pages/christmas-scavenger4/christmas-scavenger4.component';
import { ChristmasScavenger3Component } from './pages/christmas-scavenger3/christmas-scavenger3.component';
import { ChristmasScavenger2Component } from './pages/christmas-scavenger2/christmas-scavenger2.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { FacebookModule } from 'ngx-facebook';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { SETTINGS as AUTH_SETTINGS } from '@angular/fire/compat/auth';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CssFunComponent } from './pages/css-fun/css-fun.component';
import { HomeComponent } from './pages/home/home.component';
import { HeaderComponent } from './templates/header/header.component';
import { FooterComponent } from './templates/footer/footer.component';
import { BoredComponent } from './pages/bored/bored.component';

import { environment } from '../environments/environment';
import { MessagesComponent } from './pages/messages/messages.component';
import { PixelizeComponent } from './pages/pixelize/pixelize.component';

import { CustomGridComponent } from './pages/custom-grid/custom-grid.component';
import { ToolsComponent } from './templates/tools/tools.component';
import { StepsComponent } from './templates/steps/steps.component';
import { PatternModalComponent } from './modals/pattern-modal/pattern-modal.component';
import { DelayModalComponent } from './modals/delay-modal/delay-modal.component';
import { MuscleBeachComponent } from './pages/muscle-beach/muscle-beach.component';
import { IntroAnimationComponent } from './templates/intro-animation/intro-animation.component';
import { HomeCarouselComponent } from './templates/home-carousel/home-carousel.component';
import { ProjectShowComponent } from './templates/project-show/project-show.component';
import { JsCollisionComponent } from './templates/js-collision/js-collision.component';
import { PlatformerComponent } from './pages/platformer/platformer.component';
import { PhaserComponent } from './pages/phaser/phaser.component';
import { GamesComponent } from './pages/games/games.component';
import { CoupComponent } from './pages/coup/coup.component';
import { CouphomeComponent } from './pages/couphome/couphome.component';
import { AlertyComponent } from './templates/alerty/alerty.component';
import { DemoComponent } from './templates/demo/demo.component';
import { TravelStuffComponent } from './pages/travel-stuff/travel-stuff.component';


import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';

// colors
// import { ColorPickerModule } from 'ngx-color-picker';
// import { ColorHueModule } from 'ngx-color/hue';
// import { ColorShadeModule } from 'ngx-color/shade';
// import { ColorChromeModule } from 'ngx-color/chrome';
// import { ColorSliderModule } from 'ngx-color/slider';

import { ChecklistComponent } from './pages/checklist/checklist.component';
import { InstaComponent } from './pages/insta/insta.component';
import { AuthComponent } from './pages/auth/auth.component';
import { SwolecityComponent } from './pages/swolecity/swolecity.component';
import { NachoHeaderComponent } from './templates/nacho-header/nacho-header.component';
import { NachoGalleryComponent } from './pages/nacho-gallery/nacho-gallery.component';
import { ShowDemosComponent } from './pages/show-demos/show-demos.component';
import { JsFunComponent } from './pages/js-fun/js-fun.component';
import { CssPhotoColumnsComponent } from './templates/css-photo-columns/css-photo-columns.component';
import { SortPipe } from './pipes/sort.pipe';
import { PlantsComponent } from './pages/plants/plants.component';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PlantPipe } from './pipes/plant.pipe';
import { ChristmasScavengerComponent } from './pages/christmas-scavenger/christmas-scavenger.component';
import { StitchMakerComponent } from './pages/stitch-maker/stitch-maker.component';
import { WeddingRsvpComponent } from './pages/wedding-rsvp/wedding-rsvp.component';
import { BridalShowerQuestionsComponent } from './pages/bridal-shower-questions/bridal-shower-questions.component';
import { ChallengeComponent } from './pages/challenge/challenge.component';
import { DailyJournalComponent } from './pages/challenge/daily-journal.component';
import { HabitCardComponent } from './pages/challenge/habit-card.component';
import { WeeklyGoalCardComponent } from './pages/challenge/weekly-goal-card.component';
import { HabitListComponent } from './pages/challenge/habit-list.component';
import { HabitEditModalComponent } from './pages/challenge/habit-edit-modal.component';
import { HistoryModalComponent } from './pages/challenge/history-modal.component';
import { MandalaComponent } from './pages/challenge/mandala/mandala.component';
import { MandalaIconsComponent } from './pages/challenge/mandala/mandala-icons.component';
import { MandalaSettingsComponent } from './pages/challenge/mandala/mandala-settings.component';
import { StatsPanelComponent } from './pages/challenge/mandala/stats-panel.component';
import { DraftComponent } from './pages/draft/draft.component';
import { WeddingRsvpAdminComponent } from './pages/wedding-rsvp-admin/wedding-rsvp-admin.component';
import { GuitarAppComponent } from './pages/guitar-app/guitar-app.component';
import { GuitarLessonsComponent } from './pages/guitar-app/lessons.component';
import { GuitarVisualizerComponent } from './pages/guitar-app/visualizer.component';
import { FretDiagramComponent } from './pages/guitar-app/fret-diagram.component';
import { LessonDetailComponent } from './pages/guitar-app/lesson-detail.component';
import { WorkoutTrackerComponent } from './pages/workout-tracker/workout-tracker.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './pages/auth/auth.guard';
import { WorkoutLogComponent } from './pages/workout-tracker/workout-log.component';
import { CommonModule } from '@angular/common';
import { ExerciseListComponent } from './pages/workout-tracker/exercise-list.component';
import { WorkoutSidebarComponent } from './pages/workout-tracker/workout-sidebar.component';
import { ItineraryComponent } from './pages/itinerary/itinerary.component';
import { RecipeListComponent } from './pages/recipe/recipe-list/recipe-list.component';
import { RecipeDetailComponent } from './pages/recipe/recipe-detail/recipe-detail.component';
import { RecipeFormComponent } from './pages/recipe/recipe-form/recipe-form.component';
import { PcbStatorComponent } from './pages/pcb-stator/pcb-stator.component';
import { RenFaireComponent } from './pages/ren-faire/ren-faire.component';
import { BlacksmithingComponent } from './pages/blacksmithing/blacksmithing.component';
import { BlacksmithingJournalComponent } from './pages/blacksmithing/blacksmithing-journal.component';
import { BlacksmithingGalleryComponent } from './pages/blacksmithing/blacksmithing-gallery.component';
import { MachiningComponent } from './pages/machining/machining.component';
import { MachiningJournalComponent } from './pages/machining/machining-journal.component';
import { MachiningGalleryComponent } from './pages/machining/machining-gallery.component';
import { AdobeIllustratorComponent } from './pages/adobe-illustrator/adobe-illustrator.component';
import { VawtTrackerComponent } from './pages/vawt-tracker/vawt-tracker.component';
import { HoursTrackerComponent } from './pages/hours-tracker/hours-tracker.component';
import { NewInternetComponent } from './pages/new-internet/new-internet.component';
import { FeedItemComponent } from './pages/new-internet/feed-item.component';
import { FeedStreamComponent } from './pages/new-internet/feed-stream.component';
import { LibraryComponent } from './pages/new-internet/library.component';
import { HistoryComponent } from './pages/new-internet/history.component';
import { SubscriptionsComponent } from './pages/new-internet/subscriptions.component';
import { ForgeMarkdownPipe } from './pipes/forge-markdown.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { LedGridEditorComponent } from './pages/custom-grid/led-grid-editor/led-grid-editor.component';
import { AnimationTimelineComponent } from './pages/custom-grid/animation-timeline/animation-timeline.component';
import { ToolDockComponent } from './pages/custom-grid/tool-dock/tool-dock.component';
import { DesignGalleryComponent } from './pages/custom-grid/design-gallery/design-gallery.component';
import { StartScreenComponent } from './pages/custom-grid/start-screen/start-screen.component';
import { QueueStatusComponent } from './pages/custom-grid/queue-status/queue-status.component';
import { MoneyManagerComponent } from './pages/money-manager/money-manager.component';
import { TransactionsComponent } from './pages/money-manager/transactions/transactions.component';
import { CategoriesComponent } from './pages/money-manager/categories/categories.component';
import { ImportComponent } from './pages/money-manager/import/import.component';
import { DashboardComponent } from './pages/money-manager/dashboard/dashboard.component';
import { BudgetsComponent } from './pages/money-manager/budgets/budgets.component';
import { RecurringComponent } from './pages/money-manager/recurring/recurring.component';
import { AccountsComponent } from './pages/money-manager/accounts/accounts.component';
import { SavingsComponent } from './pages/money-manager/savings/savings.component';
import { ReportsComponent } from './pages/money-manager/reports/reports.component';
import { MortgageComponent } from './pages/money-manager/mortgage/mortgage.component';
import { FireComponent } from './pages/money-manager/fire/fire.component';
import { DonutChartComponent } from './pages/money-manager/charts/donut-chart.component';
import { BarChartComponent } from './pages/money-manager/charts/bar-chart.component';
import { LineChartComponent } from './pages/money-manager/charts/line-chart.component';

@NgModule({ declarations: [
        AppComponent,
        CssFunComponent,
        BoredComponent,
        HomeComponent,
        HeaderComponent,
        FooterComponent,
        MessagesComponent,
        PixelizeComponent,
        CustomGridComponent,
        ToolsComponent,
        StepsComponent,
        PatternModalComponent,
        DelayModalComponent,
        MuscleBeachComponent,
        IntroAnimationComponent,
        HomeCarouselComponent,
        ProjectShowComponent,
        JsCollisionComponent,
        PlatformerComponent,
        PhaserComponent,
        GamesComponent,
        CoupComponent,
        CouphomeComponent,
        AlertyComponent,
        DemoComponent,
        TravelStuffComponent,
        ChecklistComponent,
        InstaComponent,
        AuthComponent,
        SwolecityComponent,
        NachoHeaderComponent,
        NachoGalleryComponent,
        ShowDemosComponent,
        JsFunComponent,
        CssPhotoColumnsComponent,
        SortPipe,
        PlantsComponent,
        PlantPipe,
        ChristmasScavengerComponent,
        ChristmasScavenger2Component,
        ChristmasScavenger3Component,
        ChristmasScavenger4Component,
        StitchMakerComponent,
        WeddingRsvpComponent,
        BridalShowerQuestionsComponent,
        ChallengeComponent,
        DailyJournalComponent,
        HabitCardComponent,
        WeeklyGoalCardComponent,
        HabitListComponent,
        HabitEditModalComponent,
        HistoryModalComponent,
        MandalaComponent,
        MandalaIconsComponent,
        MandalaSettingsComponent,
        StatsPanelComponent,
        DraftComponent,
        WeddingRsvpAdminComponent,
        GuitarAppComponent,
        GuitarLessonsComponent,
        FretDiagramComponent,
        GuitarVisualizerComponent,
        LessonDetailComponent,
        WorkoutTrackerComponent,
        WorkoutLogComponent,
        ExerciseListComponent,
        LoginComponent,
        WorkoutSidebarComponent,
        ItineraryComponent,
        RecipeListComponent,
        RecipeDetailComponent,
        RecipeFormComponent,
        PcbStatorComponent,
        RenFaireComponent,
        BlacksmithingComponent,
        BlacksmithingJournalComponent,
        BlacksmithingGalleryComponent,
        MachiningComponent,
        MachiningJournalComponent,
        MachiningGalleryComponent,
        AdobeIllustratorComponent,
        VawtTrackerComponent,
        HoursTrackerComponent,
        NewInternetComponent,
        FeedItemComponent,
        FeedStreamComponent,
        LibraryComponent,
        HistoryComponent,
        SubscriptionsComponent,
        ForgeMarkdownPipe,
        SafeUrlPipe,
        SafeHtmlPipe,
        LedGridEditorComponent,
        AnimationTimelineComponent,
        ToolDockComponent,
        DesignGalleryComponent,
        StartScreenComponent,
        QueueStatusComponent,
        MoneyManagerComponent,
        DashboardComponent,
        TransactionsComponent,
        CategoriesComponent,
        BudgetsComponent,
        MortgageComponent,
        FireComponent,
        RecurringComponent,
        AccountsComponent,
        SavingsComponent,
        ReportsComponent,
        ImportComponent,
        DonutChartComponent,
        BarChartComponent,
        LineChartComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        AngularFireStorageModule,
        // ColorPickerModule,
        // ColorHueModule,
        // ColorShadeModule,
        // ColorSliderModule,
        // ColorChromeModule,
        NgbModule,
        BrowserAnimationsModule,
        AngularFireModule.initializeApp(environment.firebase),
        MatSlideToggleModule,
        CommonModule,
        DragDropModule,
        ScrollingModule], providers: [
        AlertyComponent,
        ScreenTrackingService,
        UserTrackingService,
        { provide: AUTH_SETTINGS, useValue: { appVerificationDisabledForTesting: true } },
        AuthGuard,
        provideHttpClient(withInterceptorsFromDi()),
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAnalytics(() => getAnalytics()),
        provideAuth(() => getAuth()),
        provideDatabase(() => getDatabase()),
        provideFirestore(() => getFirestore()),
        provideFunctions(() => getFunctions()),
        provideStorage(() => getStorage()),
    ] })
export class AppModule { }
